import { matchSorter } from 'match-sorter';
import type { StaticAction } from './types';

export function filterStaticActions(
  actions: StaticAction[],
  query: string,
): StaticAction[] {
  if (!query.trim()) return actions;

  const terms = query.toLowerCase().split(/\s+/);
  const matched = terms.reduce(
    (results, term) =>
      matchSorter(results, term, { keys: ['label', 'keywords'] }),
    actions,
  );

  const lq = query.toLowerCase();
  return matched.sort((a, b) => {
    const aScore = a.label.toLowerCase().startsWith(lq)
      ? 2
      : a.label.toLowerCase().includes(lq)
        ? 1
        : 0;
    const bScore = b.label.toLowerCase().startsWith(lq)
      ? 2
      : b.label.toLowerCase().includes(lq)
        ? 1
        : 0;
    return bScore - aScore;
  });
}
